import { BORDER_RADIUS } from "../../constants/borders";
import styled from 'styled-components';
export var EmbedContainer = styled.div.attrs(function (_ref) {
  var aspectRatio = _ref.aspectRatio;
  return {
    aspectRatioOffset: aspectRatio.y / aspectRatio.x * 100
  };
}).withConfig({
  componentId: "sc-1rw06lv-0"
})(["position:relative;padding-bottom:", "%;height:0;overflow:hidden;max-width:100%;border-radius:", ";& iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:none;}"], function (_ref2) {
  var aspectRatioOffset = _ref2.aspectRatioOffset;
  return aspectRatioOffset;
}, BORDER_RADIUS.large);